import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import '../../components/LogOut/LogOut.css';
import { DoorOpen } from "lucide-react";
import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';

const LogOutMethod = ({ className = 'logout-gradient', children }) => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { handleLogout } = useAuth();

  // 📌 Controla la visibilidad del modal
  const [showConfirm, setShowConfirm] = useState(false);

  // 📌 Al hacer click en el botón → abrir modal
  const handleClick = () => {
    setError('');
    setShowConfirm(true);
  };

  // ✅ Si el usuario confirma → cerrar sesión
  const handleConfirmLogout = async () => {
    if (loading) return;
    setLoading(true);
    setError('');
    try {
      await handleLogout();
      navigate('/');
      setShowConfirm(false);
    } catch (error) {
      console.error(error);
      setError('Logout fallido');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <>
      <div className='log_out'>
        <ul className='list-none'>
          <li>
            <button
              type="button"
              className={className}
              onClick={handleClick}
              title='Cerrar Sesión'
              disabled={loading}
            >
              <DoorOpen size={20} />
              {children}
            </button>
          </li>
        </ul>
      </div>

      {/* 📌 Modal de confirmación con dos botones */}
<ConfirmModal
  isOpen={showConfirm}
  type="confirm"
  title="Cerrar sesión"
  message={error || (loading ? "Cerrando sesión..." : "¿Seguro que deseas cerrar tu sesión?")}
  confirmText={loading ? "Cerrando..." : "Sí, cerrar sesión"}
  cancelText="Cancelar"
  onConfirm={handleConfirmLogout}
  onCancel={() => setShowConfirm(false)}
/>

    </>
  );
};

export default LogOutMethod;
